// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-3c0476e8]:export{primaryColor:#00a68f;infoColor:#4f6475;headerBgColor:#000;headerTextColor:#131523;headerMenuActiveTextColor:#fff}.elm-side-dropdown[data-v-3c0476e8]{color:#131523}.elm-user-dropdown-lang[data-v-3c0476e8] {overflow:hidden}.elm-user-dropdown-lang[data-v-3c0476e8] .el-dropdown-menu__item{padding:0}.elm-user-dropdown-lang[data-v-3c0476e8] .el-dropdown-menu__item a{padding:0 1.25rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
